import PropTypes from 'prop-types';
// Aca tambien podriamos meter la proptype line que se usa muchas veces

export const TypeAndObjectImputationPermissions = PropTypes.shape({
  visualize: PropTypes.bool,
  editWells: PropTypes.bool,
  editObjectImputation: PropTypes.bool
});

export const PositionLinePermissions = PropTypes.shape({
  attachedFiles: PropTypes.shape({
    visualize: PropTypes.bool,
    write: PropTypes.bool
  }),
  comments: PropTypes.shape({
    visualize: PropTypes.bool,
    send: PropTypes.bool
  }),
  expertReview: PropTypes.shape({
    visualize: PropTypes.bool,
    actionInspectorButton: PropTypes.bool
  }),
  deleteLine: PropTypes.bool,
  rectifyLine: PropTypes.bool,
  deleteUbication: PropTypes.bool,
  sendToApprove: PropTypes.bool
});

export const WorkPartPermissions = PropTypes.shape({
  addPositionLine: PropTypes.bool,
  addProvider: PropTypes.bool,
  addUbication: PropTypes.bool,
  addWellToObjectImputation: PropTypes.bool,
  createWorkPart: PropTypes.bool,
  applyTemplate: PropTypes.bool,
  deletePositionLine: PropTypes.bool,
  deleteUbication: PropTypes.bool,
  editObjectImputation: PropTypes.bool,
  headerWorkPartASDS: PropTypes.bool,
  positionLine: PositionLinePermissions,
  simplifiedCharging: PropTypes.bool
});

export const MessagePermissions = PropTypes.shape({
  visualize: PropTypes.bool,
  write: PropTypes.bool
});

export const CommunicateToPermissions = PropTypes.shape({
  visualize: PropTypes.bool,
  write: PropTypes.bool
});

export const ApproversPermissions = PropTypes.shape({
  visualize: PropTypes.bool,
  write: PropTypes.bool
});

export const AttachedFilesPermissions = PropTypes.shape({
  request: PropTypes.shape({
    delete: PropTypes.bool,
    download: PropTypes.bool,
    upload: PropTypes.bool
  }),
  workPart: PropTypes.shape({
    delete: PropTypes.bool,
    download: PropTypes.bool,
    upload: PropTypes.bool
  })
});

export const DetailPermissions = PropTypes.shape({
  replySDS: PropTypes.bool,
  approvers: ApproversPermissions,
  attachedFiles: AttachedFilesPermissions,
  communicateTo: CommunicateToPermissions,
  message: MessagePermissions,
  typeAndObjectImputation: TypeAndObjectImputationPermissions,
  workPart: WorkPartPermissions
});
